export default __webpack_public_path__ + "static/media/seo.416830c9.jpg";